import React from "react";
import * as S from "./styles";

const CrossSvg = () => {
  return (
    <S.SVG
      color="red"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7 17.3C19.1 17.7 19.1 18.3 18.7 18.7C18.5 18.9 18.3 19 18 19C17.7 19 17.5 18.9 17.3 18.7L12 13.4L6.7 18.7C6.5 18.9 6.3 19 6 19C5.7 19 5.5 18.9 5.3 18.7C4.9 18.3 4.9 17.7 5.3 17.3L10.6 12L5.3 6.7C4.9 6.3 4.9 5.7 5.3 5.3C5.7 4.9 6.3 4.9 6.7 5.3L12 10.6L17.3 5.3C17.7 4.9 18.3 4.9 18.7 5.3C19.1 5.7 19.1 6.3 18.7 6.7L13.4 12L18.7 17.3Z"
        fill="#DE3838"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="5"
        y="5"
        width="14"
        height="14"
      >
        <path
          d="M18.7 17.3C19.1 17.7 19.1 18.3 18.7 18.7C18.5 18.9 18.3 19 18 19C17.7 19 17.5 18.9 17.3 18.7L12 13.4L6.7 18.7C6.5 18.9 6.3 19 6 19C5.7 19 5.5 18.9 5.3 18.7C4.9 18.3 4.9 17.7 5.3 17.3L10.6 12L5.3 6.7C4.9 6.3 4.9 5.7 5.3 5.3C5.7 4.9 6.3 4.9 6.7 5.3L12 10.6L17.3 5.3C17.7 4.9 18.3 4.9 18.7 5.3C19.1 5.7 19.1 6.3 18.7 6.7L13.4 12L18.7 17.3Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const CheckSvg: React.FunctionComponent<{
  color?: string;
}> = ({ color }) => {
  return (
    <S.SVG
      color={color ? color : "green"}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7 7.7L9.7 18.7C9.5 18.9 9.3 19 9 19C8.7 19 8.5 18.9 8.3 18.7L3.3 13.7C2.9 13.3 2.9 12.7 3.3 12.3C3.7 11.9 4.3 11.9 4.7 12.3L9 16.6L19.3 6.3C19.7 5.9 20.3 5.9 20.7 6.3C21.1 6.7 21.1 7.3 20.7 7.7Z"
        fill="#87B43C"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="6"
        width="18"
        height="13"
      >
        <path
          d="M20.7 7.7L9.7 18.7C9.5 18.9 9.3 19 9 19C8.7 19 8.5 18.9 8.3 18.7L3.3 13.7C2.9 13.3 2.9 12.7 3.3 12.3C3.7 11.9 4.3 11.9 4.7 12.3L9 16.6L19.3 6.3C19.7 5.9 20.3 5.9 20.7 6.3C21.1 6.7 21.1 7.3 20.7 7.7Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const PersonsSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.01595 7C4.01595 4.2 6.22472 2 9.03587 2C11.847 2 14.0558 4.2 14.0558 7C14.0558 9.8 11.847 12 9.03587 12C6.22472 12 4.01595 9.8 4.01595 7ZM18.0717 19V21C18.0717 21.6 17.6702 22 17.0678 22C16.4654 22 16.0638 21.6 16.0638 21V19C16.0638 17.3 14.7586 16 13.0518 16H5.01993C3.31316 16 2.00797 17.3 2.00797 19V21C2.00797 21.6 1.60638 22 1.00398 22C0.401596 22 0 21.6 0 21V19C0 16.2 2.20877 14 5.01993 14H13.0518C15.863 14 18.0717 16.2 18.0717 19ZM9.03587 10C7.32909 10 6.02391 8.7 6.02391 7C6.02391 5.3 7.32909 4 9.03587 4C10.7426 4 12.0478 5.3 12.0478 7C12.0478 8.7 10.7426 10 9.03587 10ZM20.2805 14.2C19.7785 14.1 19.1761 14.4 19.0757 14.9C18.9753 15.4 19.2765 16 19.7785 16.1C21.0837 16.4 21.9873 17.6 21.9873 19V21C21.9873 21.6 22.3889 22 22.9913 22C23.5937 22 23.9953 21.6 23.9953 21V19C24.0957 16.7 22.5897 14.7 20.2805 14.2ZM15.0598 2.89999C15.2606 2.29999 15.7626 2 16.2646 2.2C18.9753 2.79999 20.5817 5.59999 19.8789 8.39999C19.4773 10.2 18.0717 11.5 16.2646 12H16.0638C15.5618 12 15.1602 11.7 15.0598 11.2C14.859 10.7 15.2606 10.1 15.7626 10C16.867 9.7 17.6702 8.89999 17.9714 7.79999C18.373 6.09999 17.369 4.5 15.7626 4.09999C15.2606 4 14.9594 3.39999 15.0598 2.89999Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="2"
        width="25"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.01595 7C4.01595 4.2 6.22472 2 9.03587 2C11.847 2 14.0558 4.2 14.0558 7C14.0558 9.8 11.847 12 9.03587 12C6.22472 12 4.01595 9.8 4.01595 7ZM18.0717 19V21C18.0717 21.6 17.6702 22 17.0678 22C16.4654 22 16.0638 21.6 16.0638 21V19C16.0638 17.3 14.7586 16 13.0518 16H5.01993C3.31316 16 2.00797 17.3 2.00797 19V21C2.00797 21.6 1.60638 22 1.00398 22C0.401596 22 0 21.6 0 21V19C0 16.2 2.20877 14 5.01993 14H13.0518C15.863 14 18.0717 16.2 18.0717 19ZM9.03587 10C7.32909 10 6.02391 8.7 6.02391 7C6.02391 5.3 7.32909 4 9.03587 4C10.7426 4 12.0478 5.3 12.0478 7C12.0478 8.7 10.7426 10 9.03587 10ZM20.2805 14.2C19.7785 14.1 19.1761 14.4 19.0757 14.9C18.9753 15.4 19.2765 16 19.7785 16.1C21.0837 16.4 21.9873 17.6 21.9873 19V21C21.9873 21.6 22.3889 22 22.9913 22C23.5937 22 23.9953 21.6 23.9953 21V19C24.0957 16.7 22.5897 14.7 20.2805 14.2ZM15.0598 2.89999C15.2606 2.29999 15.7626 2 16.2646 2.2C18.9753 2.79999 20.5817 5.59999 19.8789 8.39999C19.4773 10.2 18.0717 11.5 16.2646 12H16.0638C15.5618 12 15.1602 11.7 15.0598 11.2C14.859 10.7 15.2606 10.1 15.7626 10C16.867 9.7 17.6702 8.89999 17.9714 7.79999C18.373 6.09999 17.369 4.5 15.7626 4.09999C15.2606 4 14.9594 3.39999 15.0598 2.89999Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};

const DashboardSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 5.9 5.89999 1 12 1C18.1 1 23 5.9 23 12C23 18.1 18.1 23 12 23C5.89999 23 1 18.1 1 12ZM3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3C7 3 3 7 3 12ZM15.9 6.8L9.60001 8.89999C9.3 9 9 9.3 8.90001 9.6L6.8 16C6.7 16.4 6.8 16.8 7 17C7.2 17.2 7.40001 17.3 7.7 17.3C7.8 17.3 7.90001 17.3 8 17.2L14.4 15.1C14.7 15 14.9 14.8 15 14.5L17.1 8.1C17.2 7.7 17.1 7.3 16.9 7.1C16.7 6.8 16.3 6.7 15.9 6.8ZM9.3 14.6L13.3 13.3L14.6 9.3L10.6 10.6L9.3 14.6Z"
        fill="#555F73"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="22"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1 12C1 5.9 5.89999 1 12 1C18.1 1 23 5.9 23 12C23 18.1 18.1 23 12 23C5.89999 23 1 18.1 1 12ZM3 12C3 17 7 21 12 21C17 21 21 17 21 12C21 7 17 3 12 3C7 3 3 7 3 12ZM15.9 6.8L9.60001 8.89999C9.3 9 9 9.3 8.90001 9.6L6.8 16C6.7 16.4 6.8 16.8 7 17C7.2 17.2 7.40001 17.3 7.7 17.3C7.8 17.3 7.90001 17.3 8 17.2L14.4 15.1C14.7 15 14.9 14.8 15 14.5L17.1 8.1C17.2 7.7 17.1 7.3 16.9 7.1C16.7 6.8 16.3 6.7 15.9 6.8ZM9.3 14.6L13.3 13.3L14.6 9.3L10.6 10.6L9.3 14.6Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const CompaniesSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 6H17V5C17 3.3 15.7 2 14 2H10C8.3 2 7 3.3 7 5V6H4C2.3 6 1 7.3 1 9V19C1 20.7 2.3 22 4 22H20C21.7 22 23 20.7 23 19V9C23 7.3 21.7 6 20 6ZM9 5C9 4.39999 9.39999 4 10 4H14C14.6 4 15 4.39999 15 5V6H9V5ZM15 20V8H9V20H15ZM3 19V9C3 8.39999 3.39999 8 4 8H7V20H4C3.39999 20 3 19.6 3 19ZM20 20C20.6 20 21 19.6 21 19V9C21 8.39999 20.6 8 20 8H17V20H20Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="2"
        width="22"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 6H17V5C17 3.3 15.7 2 14 2H10C8.3 2 7 3.3 7 5V6H4C2.3 6 1 7.3 1 9V19C1 20.7 2.3 22 4 22H20C21.7 22 23 20.7 23 19V9C23 7.3 21.7 6 20 6ZM9 5C9 4.39999 9.39999 4 10 4H14C14.6 4 15 4.39999 15 5V6H9V5ZM15 20V8H9V20H15ZM3 19V9C3 8.39999 3.39999 8 4 8H7V20H4C3.39999 20 3 19.6 3 19ZM20 20C20.6 20 21 19.6 21 19V9C21 8.39999 20.6 8 20 8H17V20H20Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const UsersSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 7C7 4.2 9.2 2 12 2C14.8 2 17 4.2 17 7C17 9.8 14.8 12 12 12C9.2 12 7 9.8 7 7ZM21 19V21C21 21.6 20.6 22 20 22C19.4 22 19 21.6 19 21V19C19 17.3 17.7 16 16 16H8C6.3 16 5 17.3 5 19V21C5 21.6 4.60001 22 4 22C3.39999 22 3 21.6 3 21V19C3 16.2 5.2 14 8 14H16C18.8 14 21 16.2 21 19ZM12 10C10.3 10 9 8.7 9 7C9 5.3 10.3 4 12 4C13.7 4 15 5.3 15 7C15 8.7 13.7 10 12 10Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="2"
        width="18"
        height="20"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 7C7 4.2 9.2 2 12 2C14.8 2 17 4.2 17 7C17 9.8 14.8 12 12 12C9.2 12 7 9.8 7 7ZM21 19V21C21 21.6 20.6 22 20 22C19.4 22 19 21.6 19 21V19C19 17.3 17.7 16 16 16H8C6.3 16 5 17.3 5 19V21C5 21.6 4.60001 22 4 22C3.39999 22 3 21.6 3 21V19C3 16.2 5.2 14 8 14H16C18.8 14 21 16.2 21 19ZM12 10C10.3 10 9 8.7 9 7C9 5.3 10.3 4 12 4C13.7 4 15 5.3 15 7C15 8.7 13.7 10 12 10Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const ReportsSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3C11.4 3 11 3.39999 11 4V20C11 20.6 11.4 21 12 21C12.6 21 13 20.6 13 20V4C13 3.39999 12.6 3 12 3ZM19 10V20C19 20.6 18.6 21 18 21C17.4 21 17 20.6 17 20V10C17 9.39999 17.4 9 18 9C18.6 9 19 9.39999 19 10ZM5 14C5 13.4 5.39999 13 6 13C6.60001 13 7 13.4 7 14V20C7 20.6 6.60001 21 6 21C5.39999 21 5 20.6 5 20V14Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="5"
        y="3"
        width="14"
        height="18"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 3C11.4 3 11 3.39999 11 4V20C11 20.6 11.4 21 12 21C12.6 21 13 20.6 13 20V4C13 3.39999 12.6 3 12 3ZM19 10V20C19 20.6 18.6 21 18 21C17.4 21 17 20.6 17 20V10C17 9.39999 17.4 9 18 9C18.6 9 19 9.39999 19 10ZM5 14C5 13.4 5.39999 13 6 13C6.60001 13 7 13.4 7 14V20C7 20.6 6.60001 21 6 21C5.39999 21 5 20.6 5 20V14Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const EventsSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3H17V2C17 1.39999 16.6 1 16 1C15.4 1 15 1.39999 15 2V3H9V2C9 1.39999 8.60001 1 8 1C7.39999 1 7 1.39999 7 2V3H5C3.29999 3 2 4.3 2 6V20C2 21.7 3.29999 23 5 23H19C20.7 23 22 21.7 22 20V6C22 4.3 20.7 3 19 3ZM5 5H7V6C7 6.60001 7.39999 7 8 7C8.60001 7 9 6.60001 9 6V5H15V6C15 6.60001 15.4 7 16 7C16.6 7 17 6.60001 17 6V5H19C19.6 5 20 5.39999 20 6V9H4V6C4 5.39999 4.39999 5 5 5ZM5 21H19C19.6 21 20 20.6 20 20V11H4V20C4 20.6 4.39999 21 5 21Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="1"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 3H17V2C17 1.39999 16.6 1 16 1C15.4 1 15 1.39999 15 2V3H9V2C9 1.39999 8.60001 1 8 1C7.39999 1 7 1.39999 7 2V3H5C3.29999 3 2 4.3 2 6V20C2 21.7 3.29999 23 5 23H19C20.7 23 22 21.7 22 20V6C22 4.3 20.7 3 19 3ZM5 5H7V6C7 6.60001 7.39999 7 8 7C8.60001 7 9 6.60001 9 6V5H15V6C15 6.60001 15.4 7 16 7C16.6 7 17 6.60001 17 6V5H19C19.6 5 20 5.39999 20 6V9H4V6C4 5.39999 4.39999 5 5 5ZM5 21H19C19.6 21 20 20.6 20 20V11H4V20C4 20.6 4.39999 21 5 21Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const AwardsSvg: React.FunctionComponent<{
  color?: string;
}> = ({ color }) => {
  return (
    <S.SVG
      color={color}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 7.98337C20 3.59251 16.4 0 12 0C7.60001 0 4 3.59251 4 7.98337C4 10.578 5.2 12.8732 7.10001 14.2703L6 22.8524C5.89999 23.2516 6.10001 23.6507 6.39999 23.8503C6.7 24.0499 7.10001 24.0499 7.5 23.8503L12 21.1559L16.5 23.8503C16.6 23.9501 16.8 23.9501 17 23.9501C17.2 23.9501 17.4 23.8503 17.5 23.7505C17.8 23.5509 18 23.1518 17.9 22.7526L16.8 14.2703C18.8 12.8732 20 10.578 20 7.98337ZM6 7.98337C6 4.69023 8.7 1.99585 12 1.99585C15.3 1.99585 18 4.69023 18 7.98337C18 11.2765 15.3 13.9709 12 13.9709C8.7 13.9709 6 11.2765 6 7.98337ZM12.5 19.1601L15.7 21.0561L15 15.368C14.1 15.7672 13.1 15.9667 12 15.9667C10.9 15.9667 9.90001 15.7672 9 15.368L8.3 21.0561L11.5 19.1601C11.8 18.9605 12.2 18.9605 12.5 19.1601Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="0"
        width="16"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 7.98337C20 3.59251 16.4 0 12 0C7.60001 0 4 3.59251 4 7.98337C4 10.578 5.2 12.8732 7.10001 14.2703L6 22.8524C5.89999 23.2516 6.10001 23.6507 6.39999 23.8503C6.7 24.0499 7.10001 24.0499 7.5 23.8503L12 21.1559L16.5 23.8503C16.6 23.9501 16.8 23.9501 17 23.9501C17.2 23.9501 17.4 23.8503 17.5 23.7505C17.8 23.5509 18 23.1518 17.9 22.7526L16.8 14.2703C18.8 12.8732 20 10.578 20 7.98337ZM6 7.98337C6 4.69023 8.7 1.99585 12 1.99585C15.3 1.99585 18 4.69023 18 7.98337C18 11.2765 15.3 13.9709 12 13.9709C8.7 13.9709 6 11.2765 6 7.98337ZM12.5 19.1601L15.7 21.0561L15 15.368C14.1 15.7672 13.1 15.9667 12 15.9667C10.9 15.9667 9.90001 15.7672 9 15.368L8.3 21.0561L11.5 19.1601C11.8 18.9605 12.2 18.9605 12.5 19.1601Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const FilesSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9 11.6L19.4 4.7C18.9 3.7 17.9 3 16.7 3H7.2C6.10001 3 5.10001 3.6 4.60001 4.7L1.2 11.6C1 11.7 1 11.8 1 12V18C1 19.7 2.3 21 4 21H20C21.7 21 23 19.7 23 18V12C23 11.8 23 11.7 22.9 11.6ZM6.3 5.6C6.5 5.2 6.90001 5 7.20001 5H16.7C17.1 5 17.4 5.2 17.6 5.6L20.3 11H3.60001L6.3 5.6ZM20 19C20.6 19 21 18.6 21 18V13H3V18C3 18.6 3.39999 19 4 19H20ZM5.3 16.7C5.10001 16.5 5 16.3 5 16C5 15.9 5 15.7 5.10001 15.6C5.14999 15.55 5.17499 15.5 5.2 15.45C5.22499 15.4 5.25 15.35 5.3 15.3C5.39999 15.2 5.5 15.1 5.60001 15.1C5.8 15 6.10001 15 6.39999 15.1C6.5 15.1 6.60001 15.2 6.7 15.3C6.8 15.4 6.89999 15.5 6.89999 15.6C7 15.7 7 15.9 7 16C7 16.3 6.89999 16.5 6.7 16.7C6.5 16.9 6.3 17 6 17C5.7 17 5.5 16.9 5.3 16.7ZM9 16C9 16.3 9.10001 16.5 9.3 16.7C9.5 16.9 9.7 17 10 17C10.3 17 10.5 16.9 10.7 16.7C10.9 16.5 11 16.3 11 16C11 15.9 11 15.7 10.9 15.6C10.9 15.5 10.8 15.4 10.7 15.3C10.3 14.9 9.7 14.9 9.3 15.3C9.25 15.35 9.22499 15.4 9.2 15.45C9.175 15.5 9.14999 15.55 9.10001 15.6C9 15.7 9 15.9 9 16Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="3"
        width="22"
        height="18"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.9 11.6L19.4 4.7C18.9 3.7 17.9 3 16.7 3H7.2C6.10001 3 5.10001 3.6 4.60001 4.7L1.2 11.6C1 11.7 1 11.8 1 12V18C1 19.7 2.3 21 4 21H20C21.7 21 23 19.7 23 18V12C23 11.8 23 11.7 22.9 11.6ZM6.3 5.6C6.5 5.2 6.90001 5 7.20001 5H16.7C17.1 5 17.4 5.2 17.6 5.6L20.3 11H3.60001L6.3 5.6ZM20 19C20.6 19 21 18.6 21 18V13H3V18C3 18.6 3.39999 19 4 19H20ZM5.3 16.7C5.10001 16.5 5 16.3 5 16C5 15.9 5 15.7 5.10001 15.6C5.14999 15.55 5.17499 15.5 5.2 15.45C5.22499 15.4 5.25 15.35 5.3 15.3C5.39999 15.2 5.5 15.1 5.60001 15.1C5.8 15 6.10001 15 6.39999 15.1C6.5 15.1 6.60001 15.2 6.7 15.3C6.8 15.4 6.89999 15.5 6.89999 15.6C7 15.7 7 15.9 7 16C7 16.3 6.89999 16.5 6.7 16.7C6.5 16.9 6.3 17 6 17C5.7 17 5.5 16.9 5.3 16.7ZM9 16C9 16.3 9.10001 16.5 9.3 16.7C9.5 16.9 9.7 17 10 17C10.3 17 10.5 16.9 10.7 16.7C10.9 16.5 11 16.3 11 16C11 15.9 11 15.7 10.9 15.6C10.9 15.5 10.8 15.4 10.7 15.3C10.3 14.9 9.7 14.9 9.3 15.3C9.25 15.35 9.22499 15.4 9.2 15.45C9.175 15.5 9.14999 15.55 9.10001 15.6C9 15.7 9 15.9 9 16Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const StoreSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.8 5.5C21.9 5.5 21.9 5.6 21.9 5.6C22 5.8 22 5.9 22 6V20C22 21.7 20.7 23 19 23H5C3.29999 23 2 21.7 2 20V6V5.6C2.10001 5.6 2.10001 5.5 2.10001 5.5C2.20001 5.5 2.20001 5.4 2.20001 5.4L5.20001 1.4C5.39999 1.1 5.70001 1 6 1H18C18.3 1 18.6 1.1 18.7 1.4L21.7 5.4C21.8 5.4 21.8 5.5 21.8 5.5ZM17.5 3H6.5L5 5H19L17.5 3ZM20 20C20 20.6 19.6 21 19 21H5C4.39999 21 4 20.6 4 20V7H20V20ZM12 15C14.8 15 17 12.8 17 10C17 9.4 16.6 9 16 9C15.4 9 15 9.4 15 10C15 11.7 13.7 13 12 13C10.3 13 9 11.7 9 10C9 9.4 8.60001 9 8 9C7.39999 9 7 9.4 7 10C7 12.8 9.20001 15 12 15Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="1"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.8 5.5C21.9 5.5 21.9 5.6 21.9 5.6C22 5.8 22 5.9 22 6V20C22 21.7 20.7 23 19 23H5C3.29999 23 2 21.7 2 20V6V5.6C2.10001 5.6 2.10001 5.5 2.10001 5.5C2.20001 5.5 2.20001 5.4 2.20001 5.4L5.20001 1.4C5.39999 1.1 5.70001 1 6 1H18C18.3 1 18.6 1.1 18.7 1.4L21.7 5.4C21.8 5.4 21.8 5.5 21.8 5.5ZM17.5 3H6.5L5 5H19L17.5 3ZM20 20C20 20.6 19.6 21 19 21H5C4.39999 21 4 20.6 4 20V7H20V20ZM12 15C14.8 15 17 12.8 17 10C17 9.4 16.6 9 16 9C15.4 9 15 9.4 15 10C15 11.7 13.7 13 12 13C10.3 13 9 11.7 9 10C9 9.4 8.60001 9 8 9C7.39999 9 7 9.4 7 10C7 12.8 9.20001 15 12 15Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const InvoicingSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 3H3C1.3 3 0 4.3 0 6V18C0 19.7 1.3 21 3 21H21C22.7 21 24 19.7 24 18V6C24 4.3 22.7 3 21 3ZM3 5H21C21.6 5 22 5.4 22 6V9H2V6C2 5.4 2.39999 5 3 5ZM3 19H21C21.6 19 22 18.6 22 18V11H2V18C2 18.6 2.39999 19 3 19Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="3"
        width="24"
        height="18"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21 3H3C1.3 3 0 4.3 0 6V18C0 19.7 1.3 21 3 21H21C22.7 21 24 19.7 24 18V6C24 4.3 22.7 3 21 3ZM3 5H21C21.6 5 22 5.4 22 6V9H2V6C2 5.4 2.39999 5 3 5ZM3 19H21C21.6 19 22 18.6 22 18V11H2V18C2 18.6 2.39999 19 3 19Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const SettingsSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3 15.4C20.4 15.2 20.6 15 21 15C22.7 15 24 13.7 24 12C24 10.3 22.7 9 21 9H20.8C20.6 9 20.4 8.9 20.3 8.7C20.3 8.6575 20.3 8.63306 20.2923 8.61134C20.2819 8.58194 20.2575 8.5575 20.2 8.5C20.1 8.3 20.1 8 20.4 7.7C21.6 6.5 21.6 4.6 20.4 3.5C19.8 2.9 19.1 2.6 18.3 2.6C17.5 2.6 16.7 2.9 16.1 3.5C15.9 3.7 15.6 3.7 15.4 3.6C15.2 3.6 15 3.3 15 3C15 1.3 13.7 0 12 0C10.3 0 9 1.3 9 3V3.2C9 3.4 8.89999 3.6 8.7 3.7C8.65752 3.7 8.63307 3.7 8.61134 3.70767C8.58195 3.71806 8.55751 3.74249 8.5 3.8C8.3 3.9 8 3.8 7.7 3.6C6.5 2.4 4.60001 2.4 3.5 3.6C2.3 4.8 2.3 6.7 3.60001 7.9C3.8 8.1 3.8 8.4 3.7 8.7C3.60001 8.9 3.3 9.1 3 9.1C1.3 9.1 0 10.4 0 12.1C0 13.8 1.3 15.1 3 15.1H3.2C3.5 15.1 3.7 15.3 3.8 15.5C3.89999 15.7 3.89999 16 3.60001 16.3C3 16.9 2.7 17.6 2.7 18.4C2.7 19.2 3 19.9 3.60001 20.5C4.8 21.7 6.7 21.7 7.89999 20.4C8.10001 20.2 8.39999 20.2 8.7 20.3C9 20.4 9.10001 20.6 9.10001 21C9.10001 22.7 10.4 24 12.1 24C13.8 24 15.1 22.7 15.1 21V20.8C15.1 20.5 15.3 20.3 15.5 20.2C15.7 20.1 16 20.1 16.3 20.4C17.5 21.6 19.4 21.6 20.5 20.4C21.7 19.2 21.7 17.3 20.4 16.1C20.3 15.9 20.2 15.6 20.3 15.4ZM8 12C8 9.8 9.8 8 12 8C14.2 8 16 9.8 16 12C16 14.2 14.2 16 12 16C9.8 16 8 14.2 8 12ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12ZM19.1 17.6C18.3 16.7 18.1 15.6 18.5 14.6C18.9 13.6 19.9 13 20.9 13C21.6 13 22 12.6 22 12C22 11.4 21.6 11 21 11H20.8C19.8 11 18.8 10.4 18.4 9.4C18.3 9.3 18.3 9.2 18.3 9.1C18 8.2 18.2 7.1 18.9 6.4C19.4 5.9 19.4 5.3 19 4.9C18.8 4.7 18.6 4.6 18.3 4.6C18 4.6 17.8 4.7 17.6 4.9C16.7 5.7 15.6 5.9 14.6 5.5C13.6 5.1 13 4.2 13 3.1C13 2.4 12.6 2 12 2C11.4 2 11 2.4 11 3V3.2C11 4.2 10.4 5.2 9.39999 5.6C9.3 5.7 9.2 5.7 9.10001 5.7C8.2 6 7.10001 5.8 6.39999 5.1C5.89999 4.6 5.3 4.6 4.89999 5C4.5 5.4 4.5 6 4.89999 6.4C5.7 7.3 5.89999 8.4 5.5 9.4C5.10001 10.4 4.2 11.1 3.10001 11.1H3C2.39999 11.1 2 11.5 2 12.1C2 12.7 2.39999 13.1 3 13.1H3.2C4.2 13.1 5.2 13.7 5.60001 14.7C6.10001 15.7 5.89999 16.8 5.10001 17.6C4.8 17.9 4.7 18.1 4.7 18.4C4.7 18.7 4.8 18.9 5 19.1C5.39999 19.5 6 19.5 6.39999 19.1C6.89999 18.6 7.60001 18.3 8.3 18.3C8.7 18.3 9.10001 18.3 9.39999 18.5C10.4 18.9 11.1 19.8 11.1 20.9V21C11.1 21.6 11.5 22 12.1 22C12.7 22 13.1 21.6 13.1 21V20.8C13.1 19.8 13.7 18.8 14.7 18.4C15.7 17.9 16.8 18.1 17.6 18.9C17.9 19.2 18.1 19.3 18.4 19.3C18.7 19.3 18.9 19.2 19.1 19C19.3 18.8 19.4 18.6 19.4 18.3C19.4 18 19.3 17.8 19.1 17.6Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3 15.4C20.4 15.2 20.6 15 21 15C22.7 15 24 13.7 24 12C24 10.3 22.7 9 21 9H20.8C20.6 9 20.4 8.9 20.3 8.7C20.3 8.6575 20.3 8.63306 20.2923 8.61134C20.2819 8.58194 20.2575 8.5575 20.2 8.5C20.1 8.3 20.1 8 20.4 7.7C21.6 6.5 21.6 4.6 20.4 3.5C19.8 2.9 19.1 2.6 18.3 2.6C17.5 2.6 16.7 2.9 16.1 3.5C15.9 3.7 15.6 3.7 15.4 3.6C15.2 3.6 15 3.3 15 3C15 1.3 13.7 0 12 0C10.3 0 9 1.3 9 3V3.2C9 3.4 8.89999 3.6 8.7 3.7C8.65752 3.7 8.63307 3.7 8.61134 3.70767C8.58195 3.71806 8.55751 3.74249 8.5 3.8C8.3 3.9 8 3.8 7.7 3.6C6.5 2.4 4.60001 2.4 3.5 3.6C2.3 4.8 2.3 6.7 3.60001 7.9C3.8 8.1 3.8 8.4 3.7 8.7C3.60001 8.9 3.3 9.1 3 9.1C1.3 9.1 0 10.4 0 12.1C0 13.8 1.3 15.1 3 15.1H3.2C3.5 15.1 3.7 15.3 3.8 15.5C3.89999 15.7 3.89999 16 3.60001 16.3C3 16.9 2.7 17.6 2.7 18.4C2.7 19.2 3 19.9 3.60001 20.5C4.8 21.7 6.7 21.7 7.89999 20.4C8.10001 20.2 8.39999 20.2 8.7 20.3C9 20.4 9.10001 20.6 9.10001 21C9.10001 22.7 10.4 24 12.1 24C13.8 24 15.1 22.7 15.1 21V20.8C15.1 20.5 15.3 20.3 15.5 20.2C15.7 20.1 16 20.1 16.3 20.4C17.5 21.6 19.4 21.6 20.5 20.4C21.7 19.2 21.7 17.3 20.4 16.1C20.3 15.9 20.2 15.6 20.3 15.4ZM8 12C8 9.8 9.8 8 12 8C14.2 8 16 9.8 16 12C16 14.2 14.2 16 12 16C9.8 16 8 14.2 8 12ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12ZM19.1 17.6C18.3 16.7 18.1 15.6 18.5 14.6C18.9 13.6 19.9 13 20.9 13C21.6 13 22 12.6 22 12C22 11.4 21.6 11 21 11H20.8C19.8 11 18.8 10.4 18.4 9.4C18.3 9.3 18.3 9.2 18.3 9.1C18 8.2 18.2 7.1 18.9 6.4C19.4 5.9 19.4 5.3 19 4.9C18.8 4.7 18.6 4.6 18.3 4.6C18 4.6 17.8 4.7 17.6 4.9C16.7 5.7 15.6 5.9 14.6 5.5C13.6 5.1 13 4.2 13 3.1C13 2.4 12.6 2 12 2C11.4 2 11 2.4 11 3V3.2C11 4.2 10.4 5.2 9.39999 5.6C9.3 5.7 9.2 5.7 9.10001 5.7C8.2 6 7.10001 5.8 6.39999 5.1C5.89999 4.6 5.3 4.6 4.89999 5C4.5 5.4 4.5 6 4.89999 6.4C5.7 7.3 5.89999 8.4 5.5 9.4C5.10001 10.4 4.2 11.1 3.10001 11.1H3C2.39999 11.1 2 11.5 2 12.1C2 12.7 2.39999 13.1 3 13.1H3.2C4.2 13.1 5.2 13.7 5.60001 14.7C6.10001 15.7 5.89999 16.8 5.10001 17.6C4.8 17.9 4.7 18.1 4.7 18.4C4.7 18.7 4.8 18.9 5 19.1C5.39999 19.5 6 19.5 6.39999 19.1C6.89999 18.6 7.60001 18.3 8.3 18.3C8.7 18.3 9.10001 18.3 9.39999 18.5C10.4 18.9 11.1 19.8 11.1 20.9V21C11.1 21.6 11.5 22 12.1 22C12.7 22 13.1 21.6 13.1 21V20.8C13.1 19.8 13.7 18.8 14.7 18.4C15.7 17.9 16.8 18.1 17.6 18.9C17.9 19.2 18.1 19.3 18.4 19.3C18.7 19.3 18.9 19.2 19.1 19C19.3 18.8 19.4 18.6 19.4 18.3C19.4 18 19.3 17.8 19.1 17.6Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};

const PlusSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12C20 12.6 19.6 13 19 13H13V19C13 19.6 12.6 20 12 20C11.4 20 11 19.6 11 19V13H5C4.4 13 4 12.6 4 12C4 11.4 4.4 11 5 11H11V5C11 4.4 11.4 4 12 4C12.6 4 13 4.4 13 5V11H19C19.6 11 20 11.4 20 12Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="4"
        width="16"
        height="16"
      >
        <path
          d="M20 12C20 12.6 19.6 13 19 13H13V19C13 19.6 12.6 20 12 20C11.4 20 11 19.6 11 19V13H5C4.4 13 4 12.6 4 12C4 11.4 4.4 11 5 11H11V5C11 4.4 11.4 4 12 4C12.6 4 13 4.4 13 5V11H19C19.6 11 20 11.4 20 12Z"
          fill="white"
        />
      </mask>
    </svg>
  );
};
const MinusSvg = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12C20 12.6 19.6 13 19 13H5C4.4 13 4 12.6 4 12C4 11.4 4.4 11 5 11H19C19.6 11 20 11.4 20 12Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="4"
        y="11"
        width="16"
        height="2"
      >
        <path
          d="M20 12C20 12.6 19.6 13 19 13H5C4.4 13 4 12.6 4 12C4 11.4 4.4 11 5 11H19C19.6 11 20 11.4 20 12Z"
          fill="white"
        />
      </mask>
    </svg>
  );
};

const GlobeSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM20.9 11H16.9C16.7 8.2 15.8 5.6 14.2 3.3C17.8 4.2 20.5 7.3 20.9 11ZM15 13H9.1C9.3 15.7 10.3 18.3 12.1 20.4C13.7 18.3 14.7 15.7 15 13ZM9.1 11C9.4 8.3 10.4 5.7 12 3.6C13.7 5.8 14.7 8.4 14.9 11H9.1ZM7.1 11C7.3 8.2 8.2 5.6 9.7 3.3C6.2 4.2 3.5 7.3 3.1 11H7.1ZM3.1 13H7.1C7.3 15.8 8.2 18.4 9.8 20.7C6.2 19.8 3.5 16.7 3.1 13ZM17 13C16.7 15.8 15.8 18.4 14.3 20.7C17.8 19.8 20.5 16.7 21 13H17Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="22"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM20.9 11H16.9C16.7 8.2 15.8 5.6 14.2 3.3C17.8 4.2 20.5 7.3 20.9 11ZM15 13H9.1C9.3 15.7 10.3 18.3 12.1 20.4C13.7 18.3 14.7 15.7 15 13ZM9.1 11C9.4 8.3 10.4 5.7 12 3.6C13.7 5.8 14.7 8.4 14.9 11H9.1ZM7.1 11C7.3 8.2 8.2 5.6 9.7 3.3C6.2 4.2 3.5 7.3 3.1 11H7.1ZM3.1 13H7.1C7.3 15.8 8.2 18.4 9.8 20.7C6.2 19.8 3.5 16.7 3.1 13ZM17 13C16.7 15.8 15.8 18.4 14.3 20.7C17.8 19.8 20.5 16.7 21 13H17Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const PhoneSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.0414 10.4348C23.6698 10.3304 24.0887 9.8087 23.984 9.28696C23.4603 4.48696 19.5852 0.626087 14.6627 0C14.139 0 13.5106 0.417393 13.5106 0.939129C13.5106 1.46087 13.9296 1.98261 14.4532 2.08696C18.4331 2.6087 21.4704 5.63478 21.8893 9.49565C21.994 10.0174 22.413 10.4348 22.9366 10.4348H23.0414ZM17.4905 13.9826C18.3284 14.2957 19.271 14.5043 20.2136 14.6087C21.7846 14.8174 22.9366 16.1739 22.9366 17.7391V20.8696C22.9366 21.7043 22.5177 22.4348 21.994 23.0609C21.4704 23.687 20.6325 24 19.7946 24H19.4804C16.129 23.687 12.7775 22.5391 9.94968 20.6609C7.33134 18.9913 5.02721 16.6957 3.35147 14.087C1.571 11.2696 0.314194 7.93044 0 4.5913C0 3.75652 0.209473 2.92174 0.733139 2.29565C1.25681 1.66957 1.98993 1.25217 2.8278 1.14783H3.142H6.28401C7.85501 1.14783 9.21654 2.29565 9.42601 3.86087C9.53075 4.8 9.74022 5.73913 10.0544 6.57391C10.4733 7.72174 10.1591 9.07826 9.32127 9.91304L8.58815 10.6435C9.84494 12.6261 11.5207 14.1913 13.4059 15.4435L14.139 14.713C15.0816 13.8783 16.3384 13.5652 17.4905 13.9826ZM20.8419 20.8696V17.7391C20.8419 17.2174 20.423 16.8 20.0041 16.6957C18.9568 16.487 17.9094 16.2783 16.8621 15.8609C16.4431 15.6522 16.0242 15.7565 15.71 16.0696L14.3485 17.4261C14.0343 17.8435 13.5106 17.8435 13.0917 17.6348C10.2639 16.0696 7.95973 13.7739 6.38873 10.9565C6.17928 10.5391 6.284 10.0174 6.59821 9.70435L7.95973 8.45218C8.1692 8.13913 8.27394 7.72174 8.1692 7.30435C7.75027 6.36522 7.43607 5.21739 7.33134 4.17391C7.22661 3.65218 6.80768 3.23478 6.284 3.23478H3.142C2.8278 3.23478 2.5136 3.44348 2.30414 3.65218C2.1994 3.86087 2.09467 4.06956 2.09467 4.38261C2.40886 7.4087 3.45621 10.3304 5.13194 12.9391C6.70294 15.3391 8.69287 17.4261 11.1017 18.887C13.7201 20.5565 16.6526 21.6 19.6899 21.913C20.1088 21.913 20.3183 21.8087 20.5278 21.6C20.7372 21.3913 20.8419 21.1826 20.8419 20.8696ZM14.4532 6.36522C13.9296 6.26087 13.5106 5.73913 13.6154 5.11304C13.7201 4.5913 14.2438 4.17392 14.8722 4.27826C17.3858 4.8 19.3757 6.67826 19.7946 9.18261C19.8994 9.70435 19.5852 10.3304 18.9568 10.4348H18.7473C18.2236 10.4348 17.8047 10.1217 17.7 9.6C17.3858 7.93044 16.129 6.67826 14.4532 6.36522Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.0414 10.4348C23.6698 10.3304 24.0887 9.8087 23.984 9.28696C23.4603 4.48696 19.5852 0.626087 14.6627 0C14.139 0 13.5106 0.417393 13.5106 0.939129C13.5106 1.46087 13.9296 1.98261 14.4532 2.08696C18.4331 2.6087 21.4704 5.63478 21.8893 9.49565C21.994 10.0174 22.413 10.4348 22.9366 10.4348H23.0414ZM17.4905 13.9826C18.3284 14.2957 19.271 14.5043 20.2136 14.6087C21.7846 14.8174 22.9366 16.1739 22.9366 17.7391V20.8696C22.9366 21.7043 22.5177 22.4348 21.994 23.0609C21.4704 23.687 20.6325 24 19.7946 24H19.4804C16.129 23.687 12.7775 22.5391 9.94968 20.6609C7.33134 18.9913 5.02721 16.6957 3.35147 14.087C1.571 11.2696 0.314194 7.93044 0 4.5913C0 3.75652 0.209473 2.92174 0.733139 2.29565C1.25681 1.66957 1.98993 1.25217 2.8278 1.14783H3.142H6.28401C7.85501 1.14783 9.21654 2.29565 9.42601 3.86087C9.53075 4.8 9.74022 5.73913 10.0544 6.57391C10.4733 7.72174 10.1591 9.07826 9.32127 9.91304L8.58815 10.6435C9.84494 12.6261 11.5207 14.1913 13.4059 15.4435L14.139 14.713C15.0816 13.8783 16.3384 13.5652 17.4905 13.9826ZM20.8419 20.8696V17.7391C20.8419 17.2174 20.423 16.8 20.0041 16.6957C18.9568 16.487 17.9094 16.2783 16.8621 15.8609C16.4431 15.6522 16.0242 15.7565 15.71 16.0696L14.3485 17.4261C14.0343 17.8435 13.5106 17.8435 13.0917 17.6348C10.2639 16.0696 7.95973 13.7739 6.38873 10.9565C6.17928 10.5391 6.284 10.0174 6.59821 9.70435L7.95973 8.45218C8.1692 8.13913 8.27394 7.72174 8.1692 7.30435C7.75027 6.36522 7.43607 5.21739 7.33134 4.17391C7.22661 3.65218 6.80768 3.23478 6.284 3.23478H3.142C2.8278 3.23478 2.5136 3.44348 2.30414 3.65218C2.1994 3.86087 2.09467 4.06956 2.09467 4.38261C2.40886 7.4087 3.45621 10.3304 5.13194 12.9391C6.70294 15.3391 8.69287 17.4261 11.1017 18.887C13.7201 20.5565 16.6526 21.6 19.6899 21.913C20.1088 21.913 20.3183 21.8087 20.5278 21.6C20.7372 21.3913 20.8419 21.1826 20.8419 20.8696ZM14.4532 6.36522C13.9296 6.26087 13.5106 5.73913 13.6154 5.11304C13.7201 4.5913 14.2438 4.17392 14.8722 4.27826C17.3858 4.8 19.3757 6.67826 19.7946 9.18261C19.8994 9.70435 19.5852 10.3304 18.9568 10.4348H18.7473C18.2236 10.4348 17.8047 10.1217 17.7 9.6C17.3858 7.93044 16.129 6.67826 14.4532 6.36522Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const EmailSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 2.9C23 2.8 23 2.7 22.9 2.6V2.5C22.9 2.4 22.8 2.3 22.7 2.2C22.65 2.15 22.6 2.125 22.55 2.1C22.5 2.075 22.45 2.05 22.4 2H22.3C22.2 2 22.1 2 22 1.9V2C21.9 2 21.8 2 21.7 2.1L1.7 9.1C1.3 9.2 1 9.5 1 10C1 10.4 1.2 10.8 1.6 11L10.2 14.8L14 23.4C14.2 23.8 14.5 24 14.9 24C15.3 24 15.7 23.7 15.8 23.3L22.8 3.3C23 3.2 23 3.1 23 2.9ZM18.2 5.4L10.8 12.8L4.7 10.1L18.2 5.4ZM12.2 14.2L14.9 20.3L19.6 6.8L12.2 14.2Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="1"
        y="1"
        width="22"
        height="23"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23 2.9C23 2.8 23 2.7 22.9 2.6V2.5C22.9 2.4 22.8 2.3 22.7 2.2C22.65 2.15 22.6 2.125 22.55 2.1C22.5 2.075 22.45 2.05 22.4 2H22.3C22.2 2 22.1 2 22 1.9V2C21.9 2 21.8 2 21.7 2.1L1.7 9.1C1.3 9.2 1 9.5 1 10C1 10.4 1.2 10.8 1.6 11L10.2 14.8L14 23.4C14.2 23.8 14.5 24 14.9 24C15.3 24 15.7 23.7 15.8 23.3L22.8 3.3C23 3.2 23 3.1 23 2.9ZM18.2 5.4L10.8 12.8L4.7 10.1L18.2 5.4ZM12.2 14.2L14.9 20.3L19.6 6.8L12.2 14.2Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const BookSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/S.SVG"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 1H6.5C4.60001 1 3 2.60001 3 4.5V19.5C3 21.4 4.60001 23 6.5 23H20C20.6 23 21 22.6 21 22V2C21 1.39999 20.6 1 20 1ZM6.5 3H19V16H6.5C6 16 5.5 16.1 5 16.4V4.5C5 3.7 5.7 3 6.5 3ZM5 19.5C5 20.3 5.7 21 6.5 21H19V18H6.5C5.7 18 5 18.7 5 19.5Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="3"
        y="1"
        width="18"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 1H6.5C4.60001 1 3 2.60001 3 4.5V19.5C3 21.4 4.60001 23 6.5 23H20C20.6 23 21 22.6 21 22V2C21 1.39999 20.6 1 20 1ZM6.5 3H19V16H6.5C6 16 5.5 16.1 5 16.4V4.5C5 3.7 5.7 3 6.5 3ZM5 19.5C5 20.3 5.7 21 6.5 21H19V18H6.5C5.7 18 5 18.7 5 19.5Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};

const CakeSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20px"
      height="20px"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/S.SVG"
    >
      <path
        d="M20.5681714,24 L3.43178571,24 C2.38388571,24 -2.02962647e-15,23.3720308 0.00484285714,22.6073077 C0.00933702792,22.3547391 0.201245212,22.1528163 0.435814286,22.1538462 L23.5641429,22.1538462 C23.7987078,22.1528652 23.9906139,22.3547456 23.9952,22.6073077 C24,23.3720308 21.6159857,24 20.5681714,24 L20.5681714,24 Z M4.28571429,15.4012154 C4.28521657,15.3451683 4.31114364,15.2926731 4.35457607,15.2617893 C4.39800849,15.2309054 4.45302007,15.2258469 4.50068571,15.2483538 C5.10683481,15.5418107 5.76398884,15.6931403 6.42857143,15.6923077 C7.36237461,15.6998839 8.27573832,15.39792 9.04474286,14.8273846 C9.14537603,14.7467653 9.2831954,14.7467653 9.38382857,14.8273846 C10.9635542,15.9806187 13.036403,15.9806187 14.6161286,14.8273846 C14.7166985,14.7467659 14.8544729,14.7467659 14.9550429,14.8273846 C15.7241709,15.397824 16.6375735,15.699776 17.5714286,15.6923077 C18.235943,15.6926715 18.8929973,15.5414942 19.4993571,15.2487231 C19.547009,15.2261621 19.6020369,15.2311912 19.645477,15.2620774 C19.6889171,15.2929635 19.71483,15.3454837 19.7142857,15.4015385 L19.7142857,20.3076923 C19.7142857,20.8174936 19.3305298,21.2307692 18.8571429,21.2307692 L5.14285714,21.2307692 C4.66947021,21.2307692 4.28571429,20.8174936 4.28571429,20.3076923 L4.28571429,15.4012154 Z M19.2621429,14.3463231 C18.7358789,14.6268364 18.1562227,14.7716235 17.5690286,14.7692308 C16.8107951,14.774942 16.0690672,14.5308459 15.4433143,14.0696769 C15.0487723,13.7685641 14.5206848,13.7685641 14.1261429,14.0696769 C12.8411786,15.0024124 11.15925,15.0024124 9.87428571,14.0696769 C9.47969536,13.7685681 8.95157607,13.7685681 8.55698571,14.0696769 C7.93114378,14.5309341 7.18928121,14.7750352 6.43092857,14.7692308 C5.84369002,14.7716552 5.26398535,14.626867 4.73768571,14.3463231 C4.45779913,14.1881702 4.28428238,13.8739521 4.28888571,13.5336 L4.28888571,11.5385077 C4.28888571,10.5188769 5.72888571,9.23081538 11.9999143,9.23081538 C18.2709429,9.23081538 19.7109857,10.5189231 19.7109857,11.5385077 L19.7109857,13.5336 C19.7155657,13.8739205 19.5420964,14.1881127 19.2622714,14.3463231 L19.2621429,14.3463231 Z M12.4285714,4.61538462 C12.6652649,4.61538462 12.8571429,4.82202242 12.8571429,5.07692308 L12.8571429,7.84615385 C12.8571429,8.1010545 12.6652649,8.30769231 12.4285714,8.30769231 L11.5714286,8.30769231 C11.3348188,8.3075649 11.1430714,8.10096441 11.1430714,7.84615385 L11.1430714,5.07692308 C11.1430714,4.82211252 11.3348188,4.61551202 11.5714286,4.61538462 L12.4285714,4.61538462 Z M12,3.69230769 C11.6587471,3.69339137 11.3311883,3.54784291 11.0899333,3.28792583 C10.8486783,3.02800875 10.7136572,2.67519499 10.7148,2.30769231 C10.7148,1.42924615 11.5772571,-6.83214169e-17 12,-6.83214169e-17 C12.4227429,-6.83214169e-17 13.2851571,1.42924615 13.2851571,2.30769231 C13.2862999,2.67518697 13.1512847,3.02799369 12.9100389,3.28790942 C12.6687932,3.54782516 12.3412455,3.69337906 12,3.69230769 L12,3.69230769 Z"
        id="Shape"
      />
    </S.SVG>
  );
};

const StarSvg: React.FunctionComponent<{
  color?: string;
  leftMargin?: boolean;
}> = ({ color, leftMargin }) => {
  return (
    <S.SVG
      color={color}
      leftMargin
      width="20"
      height="19"
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0L12.2451 6.90983H19.5106L13.6327 11.1803L15.8779 18.0902L10 13.8197L4.12215 18.0902L6.36729 11.1803L0.489435 6.90983H7.75486L10 0Z"
        fill="#fff"
      />
    </S.SVG>
  );
};
const DownarrowSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.7 9.7L12.7 15.7C12.5 15.9 12.3 16 12 16C11.7 16 11.5 15.9 11.3 15.7L5.3 9.7C4.9 9.3 4.9 8.7 5.3 8.3C5.7 7.9 6.3 7.9 6.7 8.3L12 13.6L17.3 8.3C17.7 7.9 18.3 7.9 18.7 8.3C19.1 8.7 19.1 9.3 18.7 9.7Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="5"
        y="8"
        width="14"
        height="8"
      >
        <path
          d="M18.7 9.7L12.7 15.7C12.5 15.9 12.3 16 12 16C11.7 16 11.5 15.9 11.3 15.7L5.3 9.7C4.9 9.3 4.9 8.7 5.3 8.3C5.7 7.9 6.3 7.9 6.7 8.3L12 13.6L17.3 8.3C17.7 7.9 18.3 7.9 18.7 8.3C19.1 8.7 19.1 9.3 18.7 9.7Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};
const DownloadSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6 16.9C11.5 16.9 11.4 16.8 11.3 16.7L7.3 12.7C6.89999 12.3 6.89999 11.7 7.3 11.3C7.7 10.9 8.3 10.9 8.7 11.3L11 13.6V2C11 1.4 11.4 1 12 1C12.6 1 13 1.4 13 2V13.6L15.3 11.3C15.7 10.9 16.3 10.9 16.7 11.3C17.1 11.7 17.1 12.3 16.7 12.7L12.7 16.7C12.65 16.75 12.6 16.775 12.55 16.8C12.5 16.825 12.45 16.85 12.4 16.9C12.3 17 12.1 17 12 17C11.9 17 11.7 17 11.6 16.9ZM22 20V17C22 16.4 21.6 16 21 16C20.4 16 20 16.4 20 17V20C20 20.6 19.6 21 19 21H5C4.39999 21 4 20.6 4 20V17C4 16.4 3.60001 16 3 16C2.39999 16 2 16.4 2 17V20C2 21.7 3.3 23 5 23H19C20.7 23 22 21.7 22 20Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="1"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.6 16.9C11.5 16.9 11.4 16.8 11.3 16.7L7.3 12.7C6.89999 12.3 6.89999 11.7 7.3 11.3C7.7 10.9 8.3 10.9 8.7 11.3L11 13.6V2C11 1.4 11.4 1 12 1C12.6 1 13 1.4 13 2V13.6L15.3 11.3C15.7 10.9 16.3 10.9 16.7 11.3C17.1 11.7 17.1 12.3 16.7 12.7L12.7 16.7C12.65 16.75 12.6 16.775 12.55 16.8C12.5 16.825 12.45 16.85 12.4 16.9C12.3 17 12.1 17 12 17C11.9 17 11.7 17 11.6 16.9ZM22 20V17C22 16.4 21.6 16 21 16C20.4 16 20 16.4 20 17V20C20 20.6 19.6 21 19 21H5C4.39999 21 4 20.6 4 20V17C4 16.4 3.60001 16 3 16C2.39999 16 2 16.4 2 17V20C2 21.7 3.3 23 5 23H19C20.7 23 22 21.7 22 20Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};

const FpaLogo = () => {
  return (
    <svg
      width="36"
      height="37"
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.142 32.57C18.008 33.096 18.027 33.716 18.487 34.218C18.545 34.281 18.709 34.423 18.936 34.531C19.272 34.691 23.988 36.929 23.988 36.929C24.181 33.93 25.604 30.804 27.826 28.583C29.893 26.515 32.744 25.139 35.548 24.803C35.548 24.803 33.734 19.804 33.724 19.779C33.663 19.621 33.519 19.389 33.426 19.298C32.921 18.806 32.339 18.766 31.813 18.899C28.613 19.712 25.568 21.325 23.068 23.825C20.567 26.325 18.955 29.37 18.142 32.57ZM12.48 23.825C9.98 21.325 6.935 19.712 3.735 18.899C3.209 18.766 2.627 18.806 2.122 19.298C2.029 19.389 1.884 19.621 1.824 19.779C1.814 19.804 0 24.803 0 24.803C2.803 25.139 5.654 26.515 7.722 28.583C9.944 30.804 11.367 33.93 11.559 36.929C11.559 36.929 16.276 34.691 16.612 34.531C16.838 34.423 17.003 34.281 17.061 34.218C17.521 33.716 17.539 33.096 17.406 32.57C16.593 29.37 14.98 26.325 12.48 23.825ZM23.068 13.249C25.568 15.749 28.613 17.361 31.813 18.174C32.339 18.307 32.921 18.267 33.426 17.775C33.519 17.684 33.663 17.452 33.724 17.295C33.734 17.269 35.548 12.27 35.548 12.27C32.744 11.934 29.893 10.558 27.826 8.49104C25.604 6.26904 24.181 3.14304 23.988 0.144043C23.988 0.144043 19.272 2.38204 18.936 2.54204C18.709 2.65004 18.545 2.79204 18.487 2.85504C18.027 3.35704 18.008 3.97804 18.142 4.50404C18.955 7.70304 20.567 10.748 23.068 13.249ZM12.48 13.249C9.98 15.749 6.935 17.361 3.735 18.174C3.209 18.307 2.627 18.267 2.122 17.775C2.029 17.684 1.884 17.452 1.824 17.295C1.814 17.269 0 12.27 0 12.27C2.803 11.934 5.654 10.558 7.722 8.49104C9.944 6.26904 11.367 3.14304 11.559 0.144043C11.559 0.144043 16.276 2.38204 16.612 2.54204C16.838 2.65004 17.003 2.79204 17.061 2.85504C17.521 3.35704 17.539 3.97804 17.406 4.50404C16.593 7.70304 14.98 10.748 12.48 13.249Z"
        fill="#004A86"
      />
    </svg>
  );
};

const WarningSvg: React.FunctionComponent<{
  width?: string;
  height?: string;
}> = ({ width, height }) => {
  return (
    <S.SVG
      color="orange"
      width={width ? width : "24"}
      height={width ? width : "23"}
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.054 3.34002L22.4974 16.8136C22.776 17.1643 22.883 17.677 22.977 18.1271C22.9847 18.1642 22.9924 18.2008 23 18.2369C23 18.996 22.6985 19.6601 22.0954 20.2295C21.5928 20.7988 20.7886 21.0834 19.9845 21.0834H2.89669C2.3941 21.0834 1.89152 20.9885 1.48945 20.7039C0.0822211 19.9448 -0.420362 18.142 0.383771 16.8136L8.82716 3.24513C9.0282 2.86559 9.43026 2.48606 9.83233 2.29629C10.5359 1.91675 11.3401 1.82186 12.1442 2.01163C12.9483 2.2014 13.652 2.67582 14.054 3.34002ZM19.9845 19.1857C20.1855 19.1857 20.4871 19.0908 20.6881 18.9011C20.7099 18.8599 20.7365 18.8187 20.7636 18.7766C20.8617 18.6245 20.9679 18.4598 20.8892 18.2369C20.8892 18.0471 20.8892 17.8573 20.7886 17.7625L12.2447 4.38374C11.9432 4.00421 11.3401 3.81444 10.8375 4.09909C10.7705 4.09909 10.7035 4.18343 10.6365 4.26778C10.603 4.30995 10.5694 4.35212 10.5359 4.38374L1.99204 17.7625C1.791 18.2369 1.89152 18.8062 2.3941 19.0908C2.59514 19.1857 2.69565 19.1857 2.89669 19.1857H19.9845Z"
        fill="#F69323"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="1"
        width="23"
        height="21"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.054 3.34002L22.4974 16.8136C22.776 17.1643 22.883 17.677 22.977 18.1271C22.9847 18.1642 22.9924 18.2008 23 18.2369C23 18.996 22.6985 19.6601 22.0954 20.2295C21.5928 20.7988 20.7886 21.0834 19.9845 21.0834H2.89669C2.3941 21.0834 1.89152 20.9885 1.48945 20.7039C0.0822211 19.9448 -0.420362 18.142 0.383771 16.8136L8.82716 3.24513C9.0282 2.86559 9.43026 2.48606 9.83233 2.29629C10.5359 1.91675 11.3401 1.82186 12.1442 2.01163C12.9483 2.2014 13.652 2.67582 14.054 3.34002ZM19.9845 19.1857C20.1855 19.1857 20.4871 19.0908 20.6881 18.9011C20.7099 18.8599 20.7365 18.8187 20.7636 18.7766C20.8617 18.6245 20.9679 18.4598 20.8892 18.2369C20.8892 18.0471 20.8892 17.8573 20.7886 17.7625L12.2447 4.38374C11.9432 4.00421 11.3401 3.81444 10.8375 4.09909C10.7705 4.09909 10.7035 4.18343 10.6365 4.26778C10.603 4.30995 10.5694 4.35212 10.5359 4.38374L1.99204 17.7625C1.791 18.2369 1.89152 18.8062 2.3941 19.0908C2.59514 19.1857 2.69565 19.1857 2.89669 19.1857H19.9845Z"
          fill="white"
        />
      </mask>
      <path
        d="M12.6678 13.3765H10.7343L10.4354 7.8335H12.9667L12.6678 13.3765ZM10.4589 15.4272C10.4589 15.0718 10.5643 14.7964 10.7753 14.6011C10.9862 14.4019 11.2928 14.3022 11.6952 14.3022C12.0936 14.3022 12.3944 14.4019 12.5975 14.6011C12.8046 14.7964 12.9081 15.0718 12.9081 15.4272C12.9081 15.7788 12.8007 16.0542 12.5858 16.2534C12.3749 16.4487 12.078 16.5464 11.6952 16.5464C11.3085 16.5464 11.0057 16.4487 10.787 16.2534C10.5682 16.0542 10.4589 15.7788 10.4589 15.4272Z"
        fill="#F69323"
      />
    </S.SVG>
  );
};

const LockSvg = () => {
  return (
    <S.SVG
      color="grey"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 10H18V7C18 3.7 15.3 1 12 1C8.7 1 6 3.7 6 7V10H5C3.3 10 2 11.3 2 13V20C2 21.7 3.3 23 5 23H19C20.7 23 22 21.7 22 20V13C22 11.3 20.7 10 19 10ZM8 7C8 4.8 9.8 3 12 3C14.2 3 16 4.8 16 7V10H8V7ZM19 21C19.6 21 20 20.6 20 20V13C20 12.4 19.6 12 19 12H5C4.4 12 4 12.4 4 13V20C4 20.6 4.4 21 5 21H19Z"
        fill="black"
      />
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="1"
        width="20"
        height="22"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 10H18V7C18 3.7 15.3 1 12 1C8.7 1 6 3.7 6 7V10H5C3.3 10 2 11.3 2 13V20C2 21.7 3.3 23 5 23H19C20.7 23 22 21.7 22 20V13C22 11.3 20.7 10 19 10ZM8 7C8 4.8 9.8 3 12 3C14.2 3 16 4.8 16 7V10H8V7ZM19 21C19.6 21 20 20.6 20 20V13C20 12.4 19.6 12 19 12H5C4.4 12 4 12.4 4 13V20C4 20.6 4.4 21 5 21H19Z"
          fill="white"
        />
      </mask>
    </S.SVG>
  );
};

export {
  DashboardSvg,
  CompaniesSvg,
  UsersSvg,
  ReportsSvg,
  EventsSvg,
  AwardsSvg,
  FilesSvg,
  StoreSvg,
  InvoicingSvg,
  SettingsSvg,
};
export {
  CrossSvg,
  CheckSvg,
  PersonsSvg,
  GlobeSvg,
  PhoneSvg,
  EmailSvg,
  BookSvg,
  PlusSvg,
  MinusSvg,
  StarSvg,
  DownarrowSvg,
  CakeSvg,
  WarningSvg,
  LockSvg,
  DownloadSvg,
  FpaLogo,
};
